/* global document, rp$, window */

const {
	prepareFacets,
} = require('public/js/components/search-facets');

const THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	function getFacetsModule() {
		return rp$('.search-facets-module');
	}

	$onReady({
		rp$,
		window,
		label: 'search_facets',
		fn: function () {
			loadFacets();
		},
	});

	function loadFacets() {
		prepareFacets();
	}


};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
